import { AnyAction } from 'redux';
import {
  App,
  getAnzeigenamen,
  getSpartenTypeByApp,
  isMultistoreApp,
  Vorvertrag,
} from '@ps20-frontend/frontend-models';
import { DashboardActions } from '../dashboard.actions';
import { getDashboardIcons } from '../sagas/vorvertragsUebersichtSaga';
import contentDefault from '../../data/content-default.json';

export const MAX_VERTRAGSLISTE_LENGTH = 20;

export interface VertragItem {
  asNummer: string;
  zielprodukt: App;
  vnWechsel?: boolean;
}

export interface VertragItemWithFullContract extends VertragItem {
  fullContract?: Partial<Vorvertrag>;
}

export const emptyWeiterVertrag: () => VertragItem = () => {
  return { vnWechsel: false, zielprodukt: null, asNummer: null };
};

export const weitereVertraegeReducer = function (
  sectionState: Array<Vorvertrag> = null,
  action: AnyAction,
): Array<Vorvertrag> {
  switch (action.type) {
    case DashboardActions.WEITERE_VERTRAEGE_UBERNEHMEN: {
      const payload = action.payload as VertragItemWithFullContract[];
      return payload.map(item => mapVertragItemToVorvertrag(item, item.fullContract));
    }
    default:
      return sectionState;
  }
};

export function mapVertragItemToVorvertrag(
  item: VertragItem,
  fullContract?: Partial<Vorvertrag>,
): Vorvertrag {
  const baseContract = {
    produktIds: [item.zielprodukt],
    vertragsnummer: getItemNummerWithAs(item),
    infoText: contentDefault.uebersicht.weiterevertraege.infotext,
    anzeigename: getAnzeigenamen(item.zielprodukt),
    vorbelegungAktiv: false,
    umstellungszwang: true,
    ersetzen: true,
    firmenvertrag: false,
    neugeschaeftSperren: [
      {
        appId: item.zielprodukt,
        neugeschaeftSperren: !isMultistoreApp(item.zielprodukt),
      },
    ],
    icon: getDashboardIcons([getSpartenTypeByApp(item.zielprodukt)]),
    vnWechsel: item.vnWechsel,
  } as Vorvertrag;

  if (fullContract) {
    return {
      ...baseContract,
      ...fullContract,
      infoText: baseContract.infoText,
      anzeigename: baseContract.anzeigename,
      vnWechsel: baseContract.vnWechsel,
      umstellungszwang: baseContract.umstellungszwang,
      ersetzen: baseContract.ersetzen,
      firmenvertrag: baseContract.firmenvertrag,
    };
  }

  return baseContract;
}

export function mapVorvertragToVertragItem(vorvertrag: Vorvertrag): VertragItem {
  return {
    zielprodukt: vorvertrag.produktIds[0],
    asNummer: vorvertrag.vertragsnummer.substring(3),
    vnWechsel: vorvertrag.vnWechsel,
  } as VertragItem;
}

function getItemNummerWithAs(item: VertragItem): string {
  return item.asNummer.startsWith('AS-') ? item.asNummer : 'AS-' + item.asNummer;
}
